import _ from "lodash";
import moment from "moment";

/**
 * @param {*} isoDateTime '2023-06-18T12:34:56Z'
 * @param {*} formatString 'YYYY-MM-DD HH:mm:ss'
 * @returns
 */
export const convertIsoToLocalDateTime = (isoDateTime, formatString) => {
    const momentObj = moment(isoDateTime);
    const localDateTime = momentObj.local().format(formatString);
    return localDateTime;
};

/**
 *
 * @param {*} localDateTime e.g. '2023-06-18 12:34:56'
 * @param {*} formatString e.g. 'YYYY-MM-DD HH:mm:ss'
 * @returns
 */
export const convertLocalToUTCDateTime = (localDateTime, formatString) => {
    const momentObj = moment(localDateTime, 'YYYY-MM-DD HH:mm:ss');
    const utcDateTime = momentObj.utc().format(formatString);
    return utcDateTime;
};


export const notificationObject = (resourceType, actionType) => {
    const userData = JSON.parse(localStorage.getItem('userDetails'))
    return {
        Actor: userData.firstName + " " + userData.lastName,
        ActorId: userData.id,
        ResourceType: resourceType,
        Action: actionType,
        TimeStamp: new Date().toISOString()
    }
}

export const isNumber = (text) => {
    var reg = /^[1-9+0]+$/;
    if (text === "") return true;
    return reg.test(text);
};
export const isValidateMail = (text) => {
    var reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (text === "") return true;
    return reg.test(text);
};

export const isDecimel = (text) => {
    var reg = /^[1-9+0+.]+$/;
    if (text === "") return true;
    return reg.test(text);
};

export const AddingZeroOnTime = (time) => {
    const timeConverted = time.toString().length
    if (timeConverted < 2) {
        return `0${time}`;
    } else {
        return time;
    }
};

export const tConvert1 = (time) => {
    const timeString = time;
    const timeString12hr = new Date(
        "1970-01-01T" + timeString + "Z"
    ).toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour12: false,
        hour: "numeric",
        minute: "numeric",
    });
    return timeString12hr;
}

export const tConvert = (time) => {
    const timeString = time;
    const timeString12hr = new Date(
        "1970-01-01T" + timeString + "Z"
    ).toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour12: true,
        hour: "numeric",
        minute: "numeric",
    });
    return timeString12hr;
}

export const GetError = (err) => {
    let string = ""
    if (err) {
        Object.keys(err).map((d) => {
            string = string + (err[d]).join(",")
            return ""
        })
    }
    return string
}

const depotcreation = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">New </span>
        <span className="color-for-depot-added">{value?.ResourceType} </span>
        <span className="color-for-depot-added">[{value?.ResourceName}] </span>
        <span>added by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const depotUserAllocation = (value) => {
    return <div className="style-for-nofn-content">
        <span className="actor-nofn-color">{value?.UserDetails} </span>
        <span className="color-for-depot-added">{value?.Event === "projectAssignEvent" ? "Assign" : "allocated"} </span>
        <span>to </span>
        <span className="color-for-depot-added">{value?.ResourceName} </span>
        <span>{value?.Event === "projectAssignEvent" ? "Project" : "depot"} by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const depotUserDeallocation = (value) => {
    return <div className="style-for-nofn-content">
        <span className="actor-nofn-color">{value?.UserDetails} </span>
        <span className="color-for-depot-added">removed </span>
        <span>from </span>
        <span className="color-for-depot-added">{value?.ResourceName} </span>
        <span>{value?.Event === "projectDeAllocateEvent" ? "Project" : "depot"} by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}


const clientUpdated = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Client </span>
        <span className="red-clientname-color">[{value?.ClientName}] </span>
        <span> record edited by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const clientCreated = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added"> New Client </span>
        <span className="red-clientname-color">[{value?.ClientName}] </span>
        <span>added by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const projectCreated = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">New Project </span>
        <span className="red-clientname-color">{value?.ResourceName} </span>
        <span>added to client </span>
        <span className="red-clientname-color">{value?.ClientName} </span>
        <span>by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const projectRemoved = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Project </span>
        <span className="red-clientname-color">{value?.ResourceName} </span>
        <span>removed by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const clientRemoved = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Client </span>
        <span className="red-clientname-color">{value?.ClientName} </span>
        <span>removed by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const projectUpdated = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Project </span>
        <span className="red-clientname-color">{value?.ResourceName} </span>
        <span>of client </span>
        <span className="red-clientname-color">{value?.ClientName} </span>
        <span className="color-for-depot-added">record edited </span>
        <span>by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const projectUserCreated = (value) => {
    return (
        <>
            {value?.Role === "DepotManager" ? (
                <div className="style-for-nofn-content">
                    <span className="color-for-depot-added">New Depot manager </span>
                    <span className="red-clientname-color">{value?.Name} </span>
                    <span> added by </span>
                    <span className="actor-nofn-color" >{value?.Actor}</span>
                </div>) : value?.Role === "Admin" ?
                (
                    <div className="style-for-nofn-content">
                        <span className="color-for-depot-added">New Admin </span>
                        <span className="red-clientname-color">{value?.Name} </span>
                        <span>added by </span>
                        <span className="actor-nofn-color" >{value?.Actor}</span>
                    </div>) : (
                    <div className="style-for-nofn-content">
                        <span className="actor-nofn-color">{value?.Name || value?.UserDetails || ''} </span>
                        <span>added as </span>
                        <span className="color-for-depot-added">Project Manager </span>
                        {value?.clientName && <>
                            <span>for client </span>
                            <span className="red-clientname-color">{value?.clientName} </span>
                        </>}
                        <span>by </span>
                        <span className="actor-nofn-color">{value?.Actor}</span>


                    </div>)}
        </>
    )

}

const projectNewUserCreated = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">New Project Manager </span>
        <span className="color-for-depot-added">[{value?.UserDetails}] </span>
        <span>added to </span>
        <span className="red-clientname-color">{value?.ResourceName} </span>
        <span>Project </span>
        <span>for client </span>
        <span className="red-clientname-color">{value?.ClientName} </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>

    </div>
}

const projectUserRemoved = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Project Manager </span>
        <span className="color-for-depot-added">[{value?.UserDetails}] </span>
        <span>removed from  </span>
        <span className="red-clientname-color">{value?.ResourceName} </span>
        <span>Project </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>

    </div>
}

const shipmentCreated = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Goods In </span>
        <span className="blue-color-nofn"
            onClick={() => {
                navigate(`/app/goodsin/detail/${value?.ResourceId}`)
            }}

        >[{value?.ReferenceNumber}] </span>
        <span>added in </span>
        <span className="color-for-depot-added">{value?.Location} </span>
        <span>depot by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}




const deliveryOrderCreated = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">New {value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.OrderNo}] </span>
        <span>for client </span>
        <span className="red-clientname-color">{value?.ClientName} </span>
        <span>due on </span>
        <span className="blue-color-nofn">{moment(value?.DeliveryOrderDueDate).format("DD-MMM-YYYY")} </span>
        <span>raised by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const DeliveryOrderUpdated = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">{value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }} >[{value?.DeliveryOrderNo}] </span>
        <span>record edited </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>
    </div>

}

const DeliveryOrderApproved = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">{value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.DeliveryOrderNo}] </span>
        <span>has been accepted by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>
    </div>

}

const DeliveryOrderRemoved = (value) => {
    return <div className="style-for-nofn-content  red-clientname-color">
        <span className="blue-color-nofn-semibold red-clientname-color">{value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} </span>
        <span className="blue-color-nofn red-clientname-color"
        >
            [{value?.DeliveryOrderNo}] </span>
        <span >has been </span>
        <span className="red-clientname-color">removed by </span>
        <span className="actor-nofn-color red-clientname-color">{value?.Actor} </span>
    </div>

}

const dispatchDelivered = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Dispatch order </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.OrderNo}] </span>
        <span>one vehicle is  </span>
        <span className="text-uppercase">{value.Action} </span>
        <span>and </span>
        <span className="color-for-depot-added">out for delivery</span>
    </div>
}

const dispatchDeliveredAction = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Dispatch order </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.OrderNo}] </span>
        <span>is </span>
        <span className="text-uppercase">{value?.DeliveryOrderType == "Delivery" ? "DELIVERED" : "DISPATCHED"} </span>
    </div>
}

const DeliveryOrderDelivered = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">{value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.OrderNo}] </span>
        <span>is </span>
        <span className="text-uppercase">{value.Action} </span>
    </div>
}


const deliveryOrderLoading = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">{value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} Dispatch  </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.OrderNo}] </span>
        <span>client </span>
        <span className="red-clientname-color">{value?.ClientName} </span>
        <span>started LOADING </span>
        <span>by </span>
        <span className="actor-nofn-color">{value.Actor} </span>
    </div>
}

const delivryOrderCancelled = (value, navigate) => {
    return <div className="style-for-nofn-content red-clientname-color">
        <span className="blue-color-nofn-semibold red-clientname-color ">{value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} </span>
        <span className="blue-color-nofn red-clientname-color" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.DeliveryOrderNo}] </span>
        <span>is </span>
        <span className="text-uppercase red-clientname-color">{value.Action}LED </span>
    </div>

}

const shipmentUpdated = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Goods In </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/goodsin/detail/${value?.ResourceId}`)
        }}>[{value?.ReferenceNumber}] </span>
        <span className="color-for-depot-added">record edited </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor}</span>
    </div>
}


const shipmentApproved = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Goods In </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/goodsin/detail/${value?.ResourceId}`)
        }}>[{value?.ReferenceNumber}] </span>
        <span className="color-for-depot-added">record approved </span>
        <span>by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const shipmentRemoved = (value) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Goods In </span>
        <span className="blue-color-nofn"
        >[{value?.ReferenceNumber}] </span>
        <span className="red-clientname-color">record removed </span>
        <span>by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const shipmentRevoked = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Goods In </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/goodsin/detail/${value?.ResourceId}`)
        }}>[{value?.ReferenceNumber}] </span>
        <span className="color-for-depot-added"> record revoked </span>
        <span>by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const outForDeliveryDispatch = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">{value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} Dispatch </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.OrderNo}] </span>
        <span>client </span>
        <span className="red-clientname-color">{value?.ClientName} </span>
        <span>{value?.VehicleCount} vehicles </span>
        <span className="color-for-depot-added" >out for delivery</span>
    </div>
}

const depotDeleted = (value) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Depot </span>
        <span className="blue-color-nofn">[{value?.ResourceName}] </span>
        <span>deleted by </span>
        <span className="actor-nofn-color">{value?.Actor}</span>
    </div>
}

const dispatchCreate = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">New Dispatch order </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.OrderNo}] </span>
        <span>for client </span>
        <span className="red-clientname-color">{value?.ClientName} </span>
        <span>due on </span>
        <span className="blue-color-nofn">{moment(value?.DueDate).format("DD-MMM-YYYY")} </span>
        <span>raised by </span>
        <span className="actor-nofn-color">{value?.Actor}</span>
    </div>

}

const dispatchUpdate = (value, navigate) => {
    return <div className="style-for-nofn-content">
        <span className="blue-color-nofn-semibold">Dispatch order </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>[{value?.OrderNo}] </span>
        <span className="color-for-depot-added">record edited </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor}</span>
    </div>

}

const deliveryOrderRemarkAdded = (value, navigate) => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    return <div className="style-for-nofn-content">
        <span className="actor-nofn-color">{(userDetails?.firstName + " " + userDetails?.lastName) === value?.Actor ? "You" : value?.Actor} </span>
        <span>left a remark on </span>
        <span className="blue-color-nofn-semibold">{value?.DeliveryOrderType === "Delivery" ? "Delivery order" : "Collection order"} </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/dispatchorders/detail/${value?.ResourceId}`)
        }}>{value?.DeliveryOrderNo}</span>
    </div>
}

const shipmentRemarkAdded = (value, navigate) => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    return <div className="style-for-nofn-content">
        <span className="actor-nofn-color">{(userDetails?.firstName + " " + userDetails?.lastName) === value?.Actor ? "You" : value?.Actor} </span>
        <span>left a remark on </span>
        <span className="blue-color-nofn-semibold">Goods In </span>
        <span className="blue-color-nofn" onClick={() => {
            navigate(`/app/goodsin/detail/${value?.ResourceId}`)
        }}>[{value?.ReferenceNumber}]</span>
    </div>
}


const depotEdited = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Depot </span>
        <span className="color-for-depot-added">[{value?.ResourceName}] </span>
        <span>record edited </span>
        <span>by </span>
        <span className="actor-nofn-color" >{value?.Actor}</span>
    </div>
}

const userUpdate = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">{value?.Role === "DepotManager" ? "Depot Manager" : value?.Role === "Admin" ? "Admin" : "Project Manager"} </span>
        <span className="color-for-depot-added">[{value?.UserDetails}] </span>
        <span>record edited </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor}</span>
    </div>
}

const depotUserRemoved = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Depot manager </span>
        <span className="actor-nofn-color">{value?.UserDetails} </span>
        <span>removed from </span>
        <span className="color-for-depot-added">[{value?.ResourceName}] </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor}</span>

    </div>
}

const depotRemoved = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Depot </span>
        <span className="color-for-depot-added">[{value?.ResourceName}] </span>
        <span>removed by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>
    </div>
}

const userRemoved = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">User </span>
        <span className="color-for-depot-added">[{value?.UserDetails}] </span>
        <span>removed by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>

    </div>
}

const projectUserGrantAppAccessAllocation = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">granted app access </span>
        <span>to user </span>
        <span className="color-for-depot-added">[{value?.UserDetails}] </span>
        <span>for project </span>
        <span className="red-clientname-color">{value?.ResourceName} </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>
    </div>
}

const projectUserRevokeAppAccess = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">revoked app access </span>
        <span>to user </span>
        <span className="color-for-depot-added">[{value?.UserDetails}] </span>
        <span>for project </span>
        <span className="red-clientname-color">{value?.ResourceName} </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>
    </div>
}

const deactiveDepoUser = (value) => {
    return <div className="style-for-nofn-content">
        <span className="color-for-depot-added">Depo Manager </span>
        <span className="color-for-depot-added">[{value?.UserDetails}] </span>
        <span>deactivated </span>
        <span>by </span>
        <span className="actor-nofn-color">{value?.Actor} </span>
    </div>
}


export const TemplateForNotifications = (value, navigate) => {
    const combinedConditions = `${value.ResourceType}-${value.Action}`;
    switch (combinedConditions) {
        case "Depot-Create":
            return depotcreation(value);
        case "ProjectUser-ProjectUser Allocated":
            return depotUserAllocation(value);
        case "DepotUser-DepotUser Allocated":
            return depotUserAllocation(value);
        case "ProjectUser-HasAllocated False":
            return depotUserDeallocation(value);
        case "DepotUser-DepotUser HasAllocated False":
            return depotUserDeallocation(value);
        case "DepotUser-HasAllocated False":
            return depotUserDeallocation(value);
        case "Depot-Update":
            return depotEdited(value);
        case "Depot-Delete":
            return depotRemoved(value);
        case "Depot-Deleted DepotUser":
            return depotUserRemoved(value);

        // Depot managers Activity
        case "User-Delete":
            return userRemoved(value);
        case "User-Remove":
            return userRemoved(value);
        case "User-Update":
            return userUpdate(value);
        case "Depot-Deactivate DepotUser":
            return deactiveDepoUser(value);
        case "User-Create":
            return projectUserCreated(value);
        case "Project-ProjectUser Added":
            return projectNewUserCreated(value);
        case "Project-Project User Created":
            return projectNewUserCreated(value);
        case "Project-Project User Added":
            return projectNewUserCreated(value);
        case "Project-New ProjectUser Added":
            return projectNewUserCreated(value);
        case "Project-Create":
            return projectCreated(value);
        case "Project-Delete":
            return projectRemoved(value);
        case "Project-Project User Removed":
            return projectUserRemoved(value);
        case "Client-Delete":
            return clientRemoved(value);
        case "Project-Update":
            return projectUpdated(value);
        case "Client-Update":
            return clientUpdated(value);
        case "Client-Created":
            return clientCreated(value);
        case "Project-User Allocated":
            return projectUserGrantAppAccessAllocation(value);
        case "Project-User Deallocated":
            return projectUserRevokeAppAccess(value);

        case "Shipment-Create":
            return shipmentCreated(value, navigate);

        case "Shipment-Update":
            return shipmentUpdated(value, navigate);
        case "Shipment-Approve":
            return shipmentApproved(value, navigate);
        case "Shipment-Revoke":
            return shipmentRevoked(value, navigate);
        case "Shipment-Shipment Remarks":
            return shipmentRemarkAdded(value, navigate);
        case "Shipment-Remove":
            return shipmentRemoved(value, navigate);
        case "Dispatch-Create":
            return dispatchCreate(value, navigate);
        case "Dispatch-Update":
            return dispatchUpdate(value, navigate);
        case "Dispatch-Delivered":
            return dispatchDeliveredAction(value, navigate);
        case "DeliveryOrder-Delivered":
            return DeliveryOrderDelivered(value, navigate);
        case "DeliveryOrder-Dispatched":
            return DeliveryOrderDelivered(value, navigate);
        case "DeliveryOrder-InTransit":
            return DeliveryOrderDelivered(value, navigate);
        case "DeliveryOrder-Loading":
            return deliveryOrderLoading(value, navigate);
        case "Dispatch-InTransit":
            return dispatchDelivered(value, navigate);
        case "Dispatch-OutForDelivery":
            return outForDeliveryDispatch(value, navigate);
        case "Delivery Order-Create":
            return deliveryOrderCreated(value, navigate);
        case "Delivery Order-Update":
            return DeliveryOrderUpdated(value, navigate);
        case "Delivery Order-Approve":
            return DeliveryOrderApproved(value, navigate);
        case "DeliveryOrder-Remove":
            return DeliveryOrderRemoved(value, navigate);
        case "Delivery Order-Cancel":
            return delivryOrderCancelled(value, navigate);
        case "Delivery Order-Delivery Order Remarks":
            return deliveryOrderRemarkAdded(value, navigate);
        default:
            return <></>
    }
}


export const getFloatValue = (value) => {
    return parseFloat(value)?.toFixed(2);
}

function getYearWeekListWithWeekNumber(year) {
    const weeksList = [];
    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31);

    let currentWeek = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
        currentWeek.push({
            date: new Date(currentDate),
            weekNumber: getWeekNumber(currentDate),
        });

        if (currentDate.getDay() === 5) {
            weeksList.push([...currentWeek]);
            currentWeek = [];
        }
        currentDate.setDate(currentDate.getDate() + 1);
    }
    if (currentWeek.length > 0) {
        weeksList.push([...currentWeek]);
    }

    return weeksList;
}

function getWeekNumber(date) {
    const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    const dayOfYear = Math.floor((date - firstDayOfYear) / (24 * 60 * 60 * 1000));
    const weekNumber = Math.ceil((dayOfYear + firstDayOfYear.getDay() + 1) / 7);
    return weekNumber;
}


export const getMonthWeeksWithDates = (year, month) => {
    // Example usage:
    const yearWeekListWithWeekNumber = getYearWeekListWithWeekNumber(year);
    let temp = []
    _.map(yearWeekListWithWeekNumber, (d) => {
        let lastData = moment(d[d.length - 1]?.date).get("month")
        let date = moment(d[d.length - 1]?.date)
        let currentDate = moment()
        if (currentDate.isSameOrAfter(date))
            if (lastData === month) {
                temp = [...temp, {
                    label: `Week${temp?.length + 1}`,
                    startDate: d[0]?.date,
                    endDate: d[d?.length - 1]?.date
                }]
            }
    })
    return temp
}








